// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell__2zDbF","active":"active____CuA"};